const doc = [({"en":({"js":({"admin":({"contacts":({"status_select":({"status":"Status"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;